import { FC, useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
// import { useRouter } from 'next/router';
// import { Button } from '@nebo-team-dev/vobaza.ui.button/dist';
import { Icon } from '@nebo-team-dev/vobaza.ui.icon/dist';
import { useSelector } from 'react-redux';

import type { Image as IImage } from '../../../src/models/IImage';
import { getImageVariantProps } from 'shared/lib/images';
import { toNumberWithSpaces } from 'shared/lib/formatters';
import { useCart } from '../../../shared/lib/hooks/useCart';
import { useDispatch } from 'shared/lib/hooks/useDispatch';
import { removeFavorite } from 'src/store/goods';

import { Counter } from 'widgets/Counter';
import { RootState } from 'src/store';
import PlaceholderImage from 'assets/images/placeholder_small.png';
import type { IProductError } from 'entities/products/lib/checkProductToBuy';

import { api } from '../../../global/api';
import styles from './styles.module.scss';

export type FavoriteGood = {
  id: number;
  slug: string;
  sku: number;
  name: string;
  price: number;
  list_price?: number;
  main_image?: IImage;
  is_available: boolean;
  parent_categories: { id: number; name: string }[];
  brand?: string;
  seo?: {
    page_name?: string;
  };
  on_order?: boolean;
  store_quantity?: number;
};

type Props = {
  good: FavoriteGood;
  onDelete: (id: number) => void;
  onError?: (productError: IProductError) => void;
};
const ProfileFavoriteItem: FC<Props> = ({ good, onDelete, onError }) => {
  const [isAvailable, setIsAvailable] = useState(good.is_available);
  const basketItems = useSelector((store: RootState) => store.goods.basketItems);
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(0);
  // const router = useRouter();
  const { addToCart, deleteItem, isLoading, setIsLoading } = useCart(good);

  const decreaseHandler = async () => {
    try {
      const res = await deleteItem();
      !res?.error && setQuantity((oldQuantity) => oldQuantity - 1);
      if (res?.error) {
        onError(res?.error);
        throw res.error;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const addToCartHandler = async () => {
    try {
      const res = await addToCart({ withModal: false });
      setQuantity((oldQuantity) => oldQuantity + 1);
      if (res?.available === false) setIsAvailable(false);
      if (res?.error) {
        onError(res?.error);
        throw res.error;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const removeFromFavorite = async () => {
    setIsLoading(true);
    try {
      await api.deleteGoodFavorite(good.id);
      dispatch(removeFavorite(good.id));
      onDelete(good.id);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const goodInCartQuantity = basketItems.find((item) => item.id === good.id)?.quantity;
    setQuantity(goodInCartQuantity || 0);
  }, [basketItems]);
  return (
    <div className={styles.profileFavoriteItem}>
      <Link href={`/product/${good.slug}`} passHref className={styles.profileFavoriteItemImage} target="_blank">
        {good.main_image ? (
          <Image
            {...getImageVariantProps(good.main_image.variants, 'small')}
            style={{ objectFit: 'contain' }}
            alt={good.name}
          />
        ) : (
          <Image src={PlaceholderImage} style={{ objectFit: 'contain' }} alt="placeholder" />
        )}
      </Link>
      <div className={styles.profileFavoriteItemInfoBlock}>
        <div>
          <div>
            <Link href={`/product/${good.slug}`} passHref className={styles.profileFavoriteItemTitle} target="_blank">
              {good.seo?.page_name || good.name}
            </Link>
          </div>
          {good.store_quantity === 0 && good.on_order && <div className={styles.onOrder}>Доступен под заказ</div>}
        </div>
        <Icon className={styles.profileFavoriteItemDelete} name="Trash" onClick={removeFromFavorite} />
      </div>
      <div className={styles.profileFavoriteItemRight}>
        <div className={styles.profileFavoriteItemPricesBlock}>
          <div className={styles.profileFavoriteItemPrices}>
            {good.list_price && (
              <div className={styles.profileFavoriteItemPriceOld}>{toNumberWithSpaces(good.list_price)} ₽</div>
            )}
            <div className={styles.profileFavoriteItemPrice}>{toNumberWithSpaces(good.price)} ₽</div>
          </div>
          <Icon className={styles.profileFavoriteItemDelete} name="Trash" onClick={removeFromFavorite} />
        </div>

        <div className={styles.profileFavoriteItemCart}>
          {isAvailable || good.on_order ? (
            <div className={styles.counterBlock}>
              {Boolean(quantity) && (
                <Counter
                  value={quantity}
                  decreaseHandler={decreaseHandler}
                  increaseHandler={addToCartHandler}
                  isLoading={isLoading}
                  variant="secondary"
                />
              )}
              {/* <Button
                size="big"
                className={styles.cartButton}
                onClick={
                  Boolean(quantity)
                    ? () => {
                        router.push('/cart');
                      }
                    : addToCartHandler
                }
                disabled={isLoading && !good.price}
                text={Boolean(quantity) ? 'Перейти в корзину' : 'Добавить в корзину'}
              /> */}
            </div>
          ) : (
            <div className={styles.notAavailable}>Нет в наличии</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default ProfileFavoriteItem;
